<template>
  <v-layout fill-height column>
    <div class="question" v-html="ques[0]"></div>
    <v-layout class="answer" justify-center align-center>
      <div class="solution-timer">
        <section class="solution-timer-total">
          <span class="fs-30">{{ timeObj.duration | hour }}</span>
          <span class="fs-14 text--secondary me-3">시간</span>
          <span class="fs-30">{{ timeObj.duration | min }}</span>
          <span class="fs-14 text--secondary">분</span>
        </section>
        <section class="solution-timer-plugin">
          <ClockBg class="pos-center"/>
          <div id="knobcontainer" class="pos-center text-center"></div>
        </section>
        <section class="solution-timer-selected">
          <dl class="selector-times">
            <dt class="tit">
              <span class="text--secondary">{{ startTitle }}</span>
              {{ timeObj.start | hour | ampm }}
            </dt>
            <dd class="txt">{{ timeObj.start }}</dd>
          </dl>
          <dl class="selector-times">
            <dt class="tit">
              <span class="text--secondary">{{ endTitle }}</span>
              {{ timeObj.end | hour | ampm }}
            </dt>
            <dd class="txt">{{ timeObj.end }}</dd>
          </dl>
        </section>
      </div>
    </v-layout>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
let vm = null
import store from '@/store'
import '@/assets/vendor/timeRangeWheelSlider'
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import ClockBg from '@/components/icons/ClockBg'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: false,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [0, 0, 0],
    userReply: [],
    startTitle: '시작시각',
    endTitle: '종료시각',
    timeObj: {
      start: '00:00',
      end: '00:00',
      duration: '00:00'
    },
    init: {
      start: '00:00',
      end: '00:00'
    },
  }),
  components: {
    FooterBtnsNext,
    ClockBg
  },
  filters: {
    hour(value) {
      if (value) return value.split(':')[0].trim()
      return value
    },
    min(value) {
      if (value) return value.split(':')[1].trim()
      return value
    },
    ampm(value) {
      if (value) return value < 12 ? 'AM' : 'PM'
      return null
    }
  },
  created() {
    vm = this
    this.getUnitDetailUse()
  },
  mounted() {
  },
  methods: {
    timerange() {
      window.$("#knobcontainer").timerangewheel({
        width: 260,
        height: 260,
        margin: {top: 20, left: 20, bottom: 20, right: 20},
        offset: 0,
        indicatorWidth: 30,
        handleRadius: 15,
        handleStrokeWidth: 1,
        accentColor: '#7260ff',
        handleIconColor: "#fff",
        handleStrokeColor: "#fff",
        handleFillColorStart: "#fff",
        handleFillColorEnd: "#fff",
        tickColor: "transparent",
        indicatorBackgroundColor: "#efefef",
        data: this.init,
        onChange: function (timeObj) {
          vm.timeObj = timeObj
        },
        readonly: this.cmplt
      });
    },
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              this.ques.push(quesEl.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo

                if (j == 0) {
                  this.timeObj.start = userReplyEl.reply.toString()
                  this.init.start = userReplyEl.reply.toString()
                } else if (j == 1) {
                  this.timeObj.end = userReplyEl.reply.toString()
                  this.init.end = userReplyEl.reply.toString()
                } else if (j == 2) {
                  this.timeObj.duration = userReplyEl.reply.toString()
                }
              });
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
          this.timerange()
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        this.replyObjArr.forEach((replyObj, i) => {

          // 시간값 셋팅
          var reply = ''
          if (i == 0) {
            reply = this.timeObj.start
          } else if (i == 1) {
            reply = this.timeObj.end
          } else if (i == 2) {
            reply = this.timeObj.duration
          }

          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: this.userReplyNo[i],
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: reply,
            // score: score,
            freeYn: this.free
          }
        })

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
  }
}
</script>
